export default {
  header: {
    home: "首页",
    about: "关于至臻",
    product: "产品解决方案",
    esg: "esg",
    news: "集团动态",
    join: "人才招聘",
    contact: "联系我们",
  },
  footer: {
    sitemap: "网站地图",
    hotservice: "服务热线",
    about: "关于至臻",
    about1: "公司文化",
    about2: "公司历程",
    about3: "公司布局",
    about4: "至臻研究院",
    product: "产品解决方案",
    esg: "esg",
    news: "集团动态",
    join: "人才招聘",
    contact: "联系我们",
    tel:"电话",
    mail:"邮箱",
    address:"地址"
  },
  about: {
    layout: "公司布局",
    introduction: "至臻研究院",    
  },
  product: {
    title: "代表产品",
    nav: "首页",
    area: "应用领域",
  },
  news: {
    //new_url:require('../assets/images/account.png')
    title: "集团动态",
    source: "来源",
    date: "日期",
    category1: "匀晶新闻",
    category2: "行业新闻",
    view: "查看更多",
    detail:'详情',
    tip:'暂无数据'
  },
  join:{
    title:'人才招聘',
    city:'城市',
    post:'岗位',
    tip:'暂无数据',
    description:'职位描述',
    detail:'职位详情',
    back:'返回列表'
  },
  contact: {
    title: "联系我们",
    phone: "电话",
    email: "邮箱",
    fax: "传真",
    address: "地址",
    navigation: "地图导航",
  },
};
